import React from 'react'
import Cards from './components/Cards/Cards'
import Category from './components/Category/Category'
import Subject from './components/Subject/Subject'
import Trashed from './components/Trashed/Trashed'

function Card() {
  return (
    <div className="qbm-content">
      <div className="qbm-accordion-panel">
        <Subject />
        <Category />
        <Trashed />
      </div>

      <Cards/>
    </div>
  )
}

export default Card



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Card/index.jsx